var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShutdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#D1EBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.71 8.87305C17.444 9.60734 17.9439 10.5428 18.1463 11.5612C18.3488 12.5795 18.2447 13.635 17.8473 14.5942C17.4499 15.5534 16.777 16.3733 15.9136 16.9501C15.0503 17.5269 14.0354 17.8348 12.9971 17.8348C11.9588 17.8348 10.9438 17.5269 10.0805 16.9501C9.21719 16.3733 8.54428 15.5534 8.14687 14.5942C7.74946 13.635 7.64539 12.5795 7.84782 11.5612C8.05026 10.5428 8.5501 9.60734 9.28416 8.87305",
    stroke: "#488B92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.16602V11.9993",
    stroke: "#488B92",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutdown);
export default __webpack_public_path__ + "static/media/shutdown.5370b45b58739f7cda4e06e2a981597e.svg";
export { ForwardRef as ReactComponent };